<p>selected-product-navbar works!</p>
